import styled, { css } from 'styled-components';

import { Box } from '@tradersclub/core-ui';

type CardProps = {
  haveCoupon?: boolean;
};

export const Wrapper = styled.div<CardProps>`
  ${({ haveCoupon }) => css`
    border-radius: ${haveCoupon ? `0 0 5px 5px` : `5px`};
    background: #fff;
    padding: 2rem;
  `}
`;

export const BoxCoupon = styled(Box)`
  background: linear-gradient(to right, #fb7239, #ec465a);
  border-radius: 5px 5px 0 0;
`;
